import { createSlice } from '@reduxjs/toolkit';


interface flowBuilderState {
    preferences:any;
    addedNodeList:any;
    insertData:any;
    envList:any;
    tenantList:any;
    instanceList:any;
  }
const initialState: flowBuilderState = {
    preferences:{},
    addedNodeList:[],
    insertData:[],
    envList:[],
    tenantList:[],
    instanceList:[]
    
};
export const flowBuilder = createSlice({
  name: 'flowBuilder',
  initialState: initialState,
  reducers: {
    setPreferences: (state,action:any) => { 
        state.preferences=action.payload;
      },
    setAddedNodeList: (state,action:any) => { 
        state.addedNodeList=action.payload;
      },
    setInsertData: (state,action:any) => { 
        state.insertData=action.payload;
      },
    setEnvListData: (state,action:any) => { 
        state.envList=action.payload;
      },
    setTenantListData: (state,action:any) => { 
        state.tenantList=action.payload;
      },
    setInstanceListData: (state,action:any) => { 
        state.instanceList=action.payload;
      },
    }
});

// this is for dispatch
export const { setPreferences,setAddedNodeList,setInsertData,setEnvListData,setInstanceListData,setTenantListData} = flowBuilder.actions;

// this is for configureStore
export default flowBuilder.reducer;